import { useMemo } from "react"
import { useQuery } from "urql"

import { FULL_LIST_LIMIT } from "@/constants/common"
import { EquivalencyGroupsListDocument } from "@/graphql/codegen/graphql"
import type { EquivalencyGroup, Query } from "@/graphql/codegen/graphql"

interface UseEquivalentProductGroupsProps {
  query?: string
  productIds?: number[]
  pause?: boolean
}

interface UseEquivalentProductGroupsReturn {
  groupsList: EquivalencyGroup[]
  groupsListFetching: boolean
  refetch: () => void
}

const useEquivalentProductGroups = ({
  query,
  productIds,
  pause = false,
}: UseEquivalentProductGroupsProps): UseEquivalentProductGroupsReturn => {
  const [{ data, fetching: groupsListFetching }, refetch] = useQuery<Pick<Query, "equivalencyGroup">>({
    query: EquivalencyGroupsListDocument,
    variables: {
      input: {
        filter: {
          ...(query && query.length > 1 && { query }),
          ...(productIds && { productIds }),
        },
        limit: FULL_LIST_LIMIT,
        offset: 0,
      },
    },
    pause,
  })

  const groupsList = useMemo(() => {
    if (!data?.equivalencyGroup?.list) {
      return []
    }
    if (data.equivalencyGroup.list.__typename === "EquivalencyGroupListSuccess") {
      return data.equivalencyGroup.list.equivalencyGroups as EquivalencyGroup[]
    }
    return []
  }, [data])

  return {
    groupsList,
    groupsListFetching,
    refetch,
  }
}

export default useEquivalentProductGroups
